import EmptyStateCta from 'client/Classrooms/Teacher/EmptyStateCta/EmptyStateCta.react';
import React from 'react';

interface Props {
  title: string;
  body: string;
}

const NoInsightData = ({title, body}: Props) => {
  const to = '/subjects';

  return (
    <EmptyStateCta>
      <EmptyStateCta.Heading>{title}</EmptyStateCta.Heading>
      <EmptyStateCta.Text>{body}</EmptyStateCta.Text>
      <EmptyStateCta.Button to={to}>Explore the library</EmptyStateCta.Button>
    </EmptyStateCta>
  );
};

export default NoInsightData;
